module.exports = __webpack_public_path__ + "img/dadukou.ca051f7b.png";